<template>
  <div class="modal fade" :class="{'show': showModal}" tabindex="-1" :style="{'display': (showModal ? 'block' : 'none')}" role="dialog" aria-labelledby="compose" :aria-hidden="!showModal">
    <!--begin::Modal dialog-->
    <transition enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut" mode="out-in" @after-leave="onAfterLeave" @after-enter="onAfterEnter">
      <div 
        class="modal-dialog modal-dialog-centered" 
        :class="{'modal-fullscreen': fullscreen, 'mw-650px': (!fullscreen) && (!maxwidth)}" 
        style="z-index: 1051;" v-show="showModalInside" 
        :style="{'max-width': maxwidth ? maxwidth + ' !important' : '', 'max-height': maxheight ? maxheight + ' !important' : ''}"
      >
        <!--begin::Modal content-->
        <div class="modal-content" ref="conteudo" :class="{'janela-ajustada': dimensoes}" :style="estiloJanela">
          <!--begin::Modal header-->
          <div class="modal-header pb-0 border-0" :class="{'cabecalho-movel': permiteMover}"
               @pointerdown="iniciarArrasto" @pointermove="moverJanela" @lostpointercapture="finalizarAjuste">
            <h5 v-if="title || permiteMover">
              <i v-if="permiteMover" aria-hidden="true" class="las la-arrows-alt me-1"></i>{{ title }}
            </h5>
            <button v-if="chaveArmazenamento" type="button" class="btn btn-sm btn-icon btn-active-color-primary ms-auto"
                    :title="$t('Restaurar tamanho e posição da janela')" :aria-label="$t('Restaurar tamanho e posição da janela')"
                    @click="restaurarPadraoJanela">
              <i class="las la-undo" aria-hidden="true"></i>
            </button>
            <!--begin::Close-->
            <div v-if="!hideClose" class="btn btn-sm btn-icon btn-active-color-primary" @click="fecharModalInterno">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
              <span class="svg-icon svg-icon-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                </svg>
              </span>
              <!--end::Svg Icon-->
            </div>
            <!--end::Close-->
          </div>
          <!--begin::Modal header-->
          <!--begin::Modal body-->
          <div 
            class="modal-body mx-5 mx-xl-18 pt-0 pb-15" 
            style="padding-bottom: 22.75px !important; margin: 0 !important;" 
            :style="{'overflow': nooverflow ? 'hidden' : ''}"
          >
            <slot></slot>
          </div>
          <!--end::Modal body-->
          <span v-if="permiteRedimensionar" class="alca-tamanho" aria-hidden="true"
                @pointerdown="iniciarRedimensionamento" @pointermove="redimensionar"
                @lostpointercapture="finalizarAjuste"></span>
        </div>
        <!--end::Modal content-->
      </div>
    </transition>
    <!--end::Modal dialog-->
    <div v-if="showModal" class="modal-backdrop fade show" @click="fecharModalInterno"></div>
  </div>
</template>

<script>
import JwtService from '@/core/services/jwt.service';

export default {
  name: "ModalBase",
  data() {
    return {
      showModal: false, 
      showModalInside: false,
      deslocamentoX: 0,
      deslocamentoY: 0,
      arrasto: null,
      dimensoes: null,
      redimensionamento: null
    };
  }, 
  props: ["fullscreen", "maxwidth", "maxheight", "nooverflow", "title", "hideClose", "preventClose", "movel", "redimensionavel", "chavePreferenciaJanela", "idJanela"],
  computed: {
    permiteMover() {
      return !this.fullscreen && !this.nooverflow && this.movel !== false;
    },
    permiteRedimensionar() {
      return !this.fullscreen && !this.nooverflow && this.redimensionavel !== false;
    },
    chaveArmazenamento() {
      if (!this.permiteMover && !this.permiteRedimensionar) return null;
      if (this.chavePreferenciaJanela) return this.chavePreferenciaJanela;
      const {idEmitenteML, usuario} = this.$store.getters;
      const tela = this.idJanela || this.$parent?.$options.name;
      return tela && idEmitenteML && usuario
        ? 'modalJanela:' + JSON.stringify([tela, idEmitenteML, usuario]) : null;
    },
    estiloJanela() {
      if (!this.dimensoes && !this.deslocamentoX && !this.deslocamentoY) return;
      return {
        ...this.dimensoes,
        transform: 'translate(' + this.deslocamentoX + 'px,' + this.deslocamentoY + 'px)'
      };
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.restaurarJanela);
  },
  methods: {
    async finalizarAjuste() {
      if (!this.arrasto && !this.redimensionamento) return;
      this.arrasto = null;
      this.redimensionamento = null;
      if (!this.chaveArmazenamento) return;
      await this.$nextTick();
      if (!this.showModalInside || !this.$refs.conteudo) return;
      const {left, top, width, height} = this.$refs.conteudo.getBoundingClientRect();
      try {
        JwtService.salvarGenerico(this.chaveArmazenamento, JSON.stringify({left, top, width, height}));
      } catch { /* A janela continua utilizável se o navegador bloquear o armazenamento. */ }
    },
    restaurarJanela() {
      this.centralizarJanela();
      if (!this.chaveArmazenamento || !this.showModalInside) return;
      let salva;
      try {
        salva = JSON.parse(window.localStorage.getItem(this.chaveArmazenamento));
      } catch { return; }
      if (!salva || ![salva.left, salva.top, salva.width, salva.height].every(Number.isFinite) ||
          salva.width <= 0 || salva.height <= 0) return;
      const dialogo = this.$refs.conteudo?.offsetParent?.getBoundingClientRect();
      if (!dialogo) return;
      const largura = Math.min(salva.width, this.$el.clientWidth);
      const altura = Math.min(salva.height, this.$el.clientHeight);
      this.dimensoes = {
        width: largura + 'px', height: altura + 'px',
        left: (Math.max(0, Math.min(salva.left, this.$el.clientWidth - largura)) - dialogo.left) + 'px',
        top: (Math.max(0, Math.min(salva.top, this.$el.clientHeight - altura)) - dialogo.top) + 'px'
      };
    },
    restaurarPadraoJanela() {
      this.centralizarJanela();
      try {
        JwtService.removerGenerico(this.chaveArmazenamento);
      } catch { /* O tamanho original também se aplica quando o armazenamento está bloqueado. */ }
    },
    centralizarJanela() {
      this.arrasto = null;
      this.dimensoes = null;
      this.redimensionamento = null;
      this.deslocamentoX = 0;
      this.deslocamentoY = 0;
    },
    iniciarArrasto(evento) {
      if (!this.permiteMover || !evento.isPrimary || evento.button !== 0 || evento.target.closest('.btn')) return;
      const caixa = this.$refs.conteudo.getBoundingClientRect();
      this.arrasto = {
        ponteiro: evento.pointerId,
        x: evento.clientX, y: evento.clientY,
        inicioX: this.deslocamentoX, inicioY: this.deslocamentoY,
        minX: Math.min(0, -caixa.left), maxX: Math.max(0, this.$el.clientWidth - caixa.right),
        minY: Math.min(0, -caixa.top), maxY: Math.max(0, this.$el.clientHeight - caixa.bottom)
      };
      evento.currentTarget.setPointerCapture(evento.pointerId);
    },
    moverJanela(evento) {
      const origem = this.arrasto;
      if (!origem || evento.pointerId !== origem.ponteiro) return;
      this.deslocamentoX = origem.inicioX + Math.max(origem.minX, Math.min(origem.maxX, evento.clientX - origem.x));
      this.deslocamentoY = origem.inicioY + Math.max(origem.minY, Math.min(origem.maxY, evento.clientY - origem.y));
    },
    iniciarRedimensionamento(evento) {
      if (!evento.isPrimary || evento.button !== 0) return;
      const conteudo = this.$refs.conteudo;
      const caixa = conteudo.getBoundingClientRect();
      const dialogo = conteudo.offsetParent.getBoundingClientRect();
      this.redimensionamento = {
        ponteiro: evento.pointerId, x: evento.clientX, y: evento.clientY,
        largura: caixa.width, altura: caixa.height,
        limiteX: this.$el.clientWidth - caixa.left, limiteY: this.$el.clientHeight - caixa.top
      };
      this.dimensoes = {
        left: (caixa.left - dialogo.left - this.deslocamentoX) + 'px',
        top: (caixa.top - dialogo.top - this.deslocamentoY) + 'px',
        width: caixa.width + 'px', height: caixa.height + 'px'
      };
      evento.currentTarget.setPointerCapture(evento.pointerId);
    },
    redimensionar(evento) {
      const inicio = this.redimensionamento;
      if (!inicio || evento.pointerId !== inicio.ponteiro) return;
      const largura = inicio.largura + evento.clientX - inicio.x;
      const altura = inicio.altura + evento.clientY - inicio.y;
      this.dimensoes.width = Math.min(inicio.limiteX, Math.max(Math.min(700, inicio.largura), largura)) + 'px';
      this.dimensoes.height = Math.min(inicio.limiteY, Math.max(Math.min(320, inicio.altura), altura)) + 'px';
    },
    toggleModal() {
      if (this.permiteMover || this.permiteRedimensionar) {
        this.centralizarJanela();
        if (!this.showModal) {
          window.addEventListener('resize', this.restaurarJanela);
        } else {
          window.removeEventListener('resize', this.restaurarJanela);
        }
      }
      this.showModal = !this.showModal;
      this.showModalInside = !this.showModalInside;
      if (this.showModalInside && this.chaveArmazenamento) this.$nextTick(this.restaurarJanela);
      this.$emit("toggleModal", this.showModal);
    },
    onAfterLeave() {
      window.removeEventListener('resize', this.restaurarJanela);
      this.showModal = false;
      this.$emit("toggleModal", this.showModal);
    }, 
    onAfterEnter() {
      this.showModal = true;
      this.$emit("afterToggleEnter", this.showModal);
    }, 
    fecharModalInterno() {
      if (this.preventClose) { this.$emit("solicitarFechamento"); return; }
      this.showModalInside = false;
    }
  }
}  
</script>

<style scoped>
.cabecalho-movel {cursor:grab;user-select:none;touch-action:none;}
.cabecalho-movel:active {cursor:grabbing;}
.janela-ajustada {position:absolute;}
.janela-ajustada > .modal-body {min-height:0;overflow:auto;}
.alca-tamanho {position:absolute;right:1px;bottom:1px;width:20px;height:20px;cursor:nwse-resize;touch-action:none;}
.alca-tamanho::after {content:'';position:absolute;right:3px;bottom:3px;width:11px;height:11px;background:repeating-linear-gradient(135deg,transparent 0 2px,currentColor 2px 3px);clip-path:polygon(100% 0,100% 100%,0 100%);opacity:.55;}
</style>
